import React from "react";
import styles from "./Home.module.css";
import { reactIcons } from "../../icons/reactIcons";

interface HomeNavProps {
  onOpenLogoutModal: () => void;
}

const HomeNav: React.FC<HomeNavProps> = ({ onOpenLogoutModal }) => {
  const userName = localStorage.getItem("LVFname");

  return (
    <header className={styles.homeNav}>
      <div className={styles.welcomeSection}>
        <h4>Welcome Back</h4>
        <p className={styles.userName}>{userName}</p>
      </div>

      <button className={styles.logoutButton} onClick={onOpenLogoutModal}>
        <reactIcons.PowerIcon style={{ fontSize: 18 }} />
      </button>
    </header>
  );
};

export default HomeNav;
